import { useAppSelector } from "@quest/hooks";

export function useViewAsPreview() {
  const preview = useAppSelector((state) => state.preview);
  return {
    isPreviewMode: Boolean(preview?.active),
    studentId: preview?.studentId || "",
    idpId: preview?.idpId || "",
    displayName: preview?.displayName || "",
    returnTo: preview?.returnTo || "/admin",
  };
}
